import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { EndCapProduct } from '~/core/models';

export const endCapsApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEndCap: builder.query<EndCapProduct[], CommonProductQueryParams>({
      query: ({ params }) => ({
        url: ApiUrl.LAMINATE_CAPS,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchEndCapQuery } = endCapsApi;
